import React from 'react';
import { Alert } from '@mui/material';
import { Button } from '@components';
import { Modal, Typography } from 'gd-design-library';
import WarningAmber from '@mui/icons-material/WarningAmber';
import classnames from 'classnames/bind';
import styles from './UnsubscribeConfirmationModal.module.scss';
import { makeFirstLetterLowerCase } from '@utils';
import { Order } from '@commercetools/platform-sdk';

const cx = classnames.bind(styles);

const CN = 'unsubscribe-confirmation-modal';
const mainTextClassName = `${CN}__main-text`;
const alertClassName = `${CN}__alert`;
const errorIconClassName = `${alertClassName}__error-icon`;
const buttonsRowClassName = `${CN}__buttons-row`;

interface Props {
  onUnsubscribe: (orderId: string, lineItemId: string) => Promise<Order | null>;
  handleClose: () => void;
  open: boolean;
  nextPaymentDate?: Date;
  features: string[];
  isLoading: boolean;
  orderId: string;
  lineItemId: string;
}

export const UnsubscribeConfirmationModal: React.FC<Props> = ({
  onUnsubscribe,
  handleClose,
  open,
  features,
  isLoading,
  nextPaymentDate,
  orderId,
  lineItemId
}) => (
  <Modal
    isOpen={ open }
    onClose={ handleClose }
    title='We are sorry to see you go!'
  >
    <div className={ cx(CN) }>
      <Typography className={ cx(mainTextClassName) }>
        Your monthly subscription is paid until {nextPaymentDate?.toLocaleDateString() ?? '-'}. If you would like to proceed
        with canceling your subscription, please select “Unsubscribe” below.
      </Typography>
      <Alert
        className={ cx(alertClassName) }
        severity='warning'
        icon={ (
          <WarningAmber fontSize='inherit' className={ cx(errorIconClassName) } />
        ) }
      >
        <Typography variant='h6'>
          Are you sure? You will not have the {features.map(makeFirstLetterLowerCase).join(', ')}.
        </Typography>
      </Alert>
      <div className={ cx(buttonsRowClassName) }>
        <Button variant='text' onClick={ handleClose }>
          Cancel
        </Button>
        <Button loading={ isLoading } onClick={ (): void => { onUnsubscribe(orderId, lineItemId); } }>
          Unsubscribe
        </Button>
      </div>
    </div>
  </Modal>
);

